import React, { Component } from 'react';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';

class VideoCompletionRateChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const { orderedColors } = this.props.theme;
        const { chartRef } = this;
        const series = [{
            type: 'column',
            stacking: 'normal',
            name: 'Completion Rate',
            color: orderedColors[0],
            data: helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r.completion_rate * 100 })),
                this.props.backfillBuckets
            )
        }];

        const xAxis = helpers.xAxisConfig({ type: 'datetime' });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel,
            options: {
                labels: {
                    formatter() {
                        return `${this.value}%`;
                    }
                },
                min: 0,
                max: 100
            }
        });

        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        credits: {
                            enabled: false
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        title: {
                            text: null
                        },
                        tooltip: {
                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.1f}%</b><br/>'
                        },
                        legend: {
                            enabled: this.props.legend,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        plotOptions: {
                            series: {
                                animation: {
                                    duration: this.props.animateDuration
                                },
                            },
                            column: {
                                borderWidth: 0
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(VideoCompletionRateChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/VideoCompletionRateChart.js